import { computed, unref } from 'vue';
import { useFullContent } from '@mts/hooks/web/useFullContent';
import { getAppStore } from '@/store';

export function useHeaderSetting() {
  const { getFullContent } = useFullContent();
  const appStore = getAppStore();

  const getShowFullHeaderRef = computed(() => {
    return !unref(getFullContent) && unref(getShowHeader);
  });

  const getShowHeader = computed(() => appStore.getHeaderSetting.show);

  const getShowSearch = computed(() => appStore.getHeaderSetting.showSearch);

  const getShowTenant = computed(() => appStore.getHeaderSetting.showTenant);

  const getShowFullScreen = computed(() => appStore.getHeaderSetting.showFullScreen);

  const getShowNotice = computed(() => appStore.getHeaderSetting.showNotice);

  return {
    getShowSearch,
    getShowTenant,
    getShowFullScreen,
    getShowNotice,
    getShowHeader,
    getShowFullHeaderRef,
  };
}
